import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// MUI Icons
import AddCircleIcon from "@mui/icons-material/AddCircle";


const MapRouteBoxOnePoint = () => {

  const { t } = useTranslation();

  return (
    <Box width="100%" m={0} p={0}>
      <Typography variant="h6" component="h2">
        {" "}
        {t("titles.route_one_point")}
      </Typography>
      <Box mt={2} p={0} width="100%" display="flex" flex="row">
        <Typography variant="body1">
          {t("routes.info_one_point")}{" "}
          <AddCircleIcon
            sx={{
              verticalAlign: "bottom",
              paddingLeft: 0,
              paddingRight: 0,
              marginLeft: 0,
              marginRight: 0,
            }}
            color="primary"
          />
        </Typography>
      </Box>
    </Box>
  );
}

export default MapRouteBoxOnePoint;
